import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import { useApi } from '../api/useApi';
import type { MeDto } from '../api/types';

interface SessionState {
  me?: MeDto;
  loading: boolean;
}

const SessionContext = createContext<SessionState>({ loading: true });

// eslint-disable-next-line react-refresh/only-export-components
export const useSession = (): SessionState => useContext(SessionContext);

/**
 * Lädt das Profil des angemeldeten Nutzers (inkl. Admin-Flag und
 * zugänglichen Service-IDs) einmal nach der Anmeldung.
 */
export function SessionProvider({ children }: { children: ReactNode }) {
  const api = useApi();
  const [state, setState] = useState<SessionState>({ loading: true });

  useEffect(() => {
    let active = true;
    api
      .getMe()
      .then((me) => {
        if (active) setState({ me, loading: false });
      })
      .catch(() => {
        if (active) setState({ loading: false });
      });
    return () => {
      active = false;
    };
  }, [api]);

  return <SessionContext.Provider value={state}>{children}</SessionContext.Provider>;
}
